import {
  errorMessages
} from "./chunk-CXY23WTR.mjs";
import {
  getApiUrl
} from "./chunk-U6P4P65O.mjs";
import {
  DecodeJwtError,
  GetProfileResponseError
} from "./chunk-5XZTHQBU.mjs";

// src/services/profile.ts
import { decodeJwt } from "@inner-source/ciam-sdk";
async function getProfile(environment, token, pcid) {
  try {
    const getProfileUrl = `${getApiUrl(environment)}/v1/customers/${pcid}/profile`;
    const getProfileResponse = await fetch(getProfileUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    return getProfileResponse.json();
  } catch (error) {
    throw new GetProfileResponseError(
      errorMessages.GET_PROFILE_CALL_ERROR + pcid
    );
  }
}
function getPcidFromJwt(token) {
  try {
    const decoded = decodeJwt(token);
    const { pcid } = decoded.payload;
    return pcid;
  } catch (error) {
    throw new DecodeJwtError(errorMessages.DECODE_JWT_ERROR);
  }
  return null;
}

export {
  getProfile,
  getPcidFromJwt
};
